// @ts-strict-ignore
export function isJSON(val) {
  if (val) {
    try {
      JSON.parse(val);
    } catch (e) {
      return false;
    }
    return true;
  }
  return false;
}
